export const getBundleName = () => {
    let bundleName = 'unknown';
    const scripts = document.querySelectorAll('script');
    scripts.forEach(script => {
        if(script.src && script.src.includes('/js/main')){
            bundleName = script.src.replace(/.*\//, '')
        }
    });
    return bundleName;
}